const state = {
  passoAtual: 1,
  listaDocumentos: [],
  tipoJuntadaSelecionada: {},
  documentoSelecionado: {}
}

export default state
